import { useState, useEffect } from 'react'

import { getErTypesAPI } from '../services/emergency'

function UseErTypes() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getOrganization = async () => {
      const result = await getErTypesAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.relation_name }
      })

      setData(newData)
    }
    getOrganization()
  }, [])

  return data
}

export default UseErTypes
